import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useProjectCommandState from '@/hooks/useProjectCommandState';

const WorkLiveContext = createContext(null);

export function WorkLiveProvider({ value, children }) {
  return (
    <WorkLiveContext.Provider value={value}>
      {children}
    </WorkLiveContext.Provider>
  );
}

WorkLiveProvider.propTypes = {
  value: PropTypes.object,
  children: PropTypes.node,
};

export function useWorkLive() {
  return useContext(WorkLiveContext);
}

export function useWorkLiveValue({
  taskId,
  taskStatus,
  taskError,
  cancellationPending = false,
  isActive,
  activityStatus,
  activityIcon,
  activityStartedAt = null,
  lastEventAt,
  browserState,
  liveStartTs = null,
}) {
  const commands = useProjectCommandState(taskId, isActive);
  return useMemo(() => ({
    taskId,
    taskStatus,
    taskError,
    cancellationPending: cancellationPending || commands.stopping,
    commandJobs: commands.jobs,
    isActive,
    activityStatus,
    activityIcon,
    activityStartedAt,
    lastEventAt,
    browserState,
    liveStartTs,
  }), [taskId, taskStatus, taskError, cancellationPending, commands.stopping, commands.jobs, isActive, activityStatus, activityIcon, activityStartedAt, lastEventAt, browserState, liveStartTs]);
}
